.scan-to-batch-button {
  margin-left: 10px;
}
